/**
 * 系统管理路由配置
 */
export default [
  {
    path: '/system/user-management',
    name: 'UserManagement',
    component: () => import('@/views/system/user-management/index.vue'),
    meta: {
      title: '用户管理',
      icon: 'User',
      requiresAuth: true,
      roles: ['admin', 'system_admin']
    }
  },
  {
    path: '/system/role-management',
    name: 'RoleManagement',
    component: () => import('@/views/system/role-management/index.vue'),
    meta: {
      title: '角色管理',
      icon: 'UserFilled',
      requiresAuth: true,
      roles: ['admin', 'system_admin']
    }
  },
  {
    path: '/system/permission-management',
    name: 'PermissionManagement',
    component: () => import('@/views/system/permission-management/index.vue'),
    meta: {
      title: '权限管理',
      icon: 'Lock',
      requiresAuth: true,
      roles: ['admin', 'system_admin']
    }
  },
  {
    path: '/system/ip-whitelist',
    name: 'IPWhitelist',
    component: () => import('@/views/system/ip-whitelist/index.vue'),
    meta: {
      title: 'IP白名单管理',
      icon: 'Lock',
      requiresAuth: true,
      roles: ['admin', 'system_admin']
    }
  }
]
